import { include } from 'named-urls';

const routes = {
  blank: '/',
  home: '/home',
  planSearchForm: include('/(suites|dining-shopping|dates|deals)', {
    t2: '',
    t3: '/*'
  }),
  dynamicFlow: include('/booking', {
    self: '',
    flowSteps: ':slugUrl'
  }),
  plan: include('/plan', {
    self: '',
    activities: 'packages-activities',
    dining: 'packages-dining',
    payment: 'payment',
    paymentSuccess: 'confirmation'
  }),
  birthdayParties: include('/birthday-parties', {
    self: '',
    partySelect: 'booking',
    foodDrinks: 'food-drinks',
    packagesAddons: 'packages-addons',
    guestInfo: 'guest-info',
    payment: 'payment',
    paymentSuccess: 'confirmation',
    requestForm: 'birthday-party-request-form'
  }),
  daypass: include('/daypass', {
    self: '',
    payment: 'payment',
    booking: 'booking',
    paymentSuccess: 'confirmation'
  }),
  forgotPassword: '/forgotpassword',
  changePassword: '/changepassword',
  unlockAccount: '/unlockaccount',
  myRecentSearches: '/my-recent-searches',
  profile: include('/user/profile', {
    self: '',
    myPreferences: 'my-preferences'
  }),
  reservations: include('/reservations', {
    self: '',
    myReservations: include('my-reservations', {
      self: '',
      detail: include(':reservationId', {
        self: '',
        packagemodal: '(cabanas|passes|birthday-packages|dining|lco)'
      }),
      modify: include(':reservationId/modify', {
        suites: 'suites',
        activities: 'packages-activities',
        dining: 'packages-dining',
        payment: 'payment'
      })
    }),
    search: 'search/'
  }),
  reservation: include('/reservation', {
    self: '',
    detail: include(':reservationId', {
      self: '',
      checkIn: 'check-in',
      folio: 'folio'
    })
  }),
  promoSignUp: '/promo-sign-up',
  referAFriend: '/user/refer-a-friend',
  referAFriendLoggedOut: '/refer-a-friend',
  widget: '/widget',
  voyagersClub: '/voyagers-club'
};

export default routes;
